import { z } from 'zod';

const vitalsSchema = z.object({
  bp: z.string().optional(),
  hr: z.string().optional(),
  temp: z.string().optional(),
  spo2: z.string().optional(),
  bmi: z.string().optional(),
}).optional();

export const encounterSchema = z.object({
  patientId: z.string().min(1, 'Patient is required'),
  doctorId: z.string().min(1, 'Doctor is required'),
  appointmentId: z.string().optional(),
  vitals: vitalsSchema,
  complaints: z.string().optional(),
  notes: z.string().optional(),
  primaryDiagnosis: z.string().optional(),
  diagnosisCode: z.string().optional(),
  status: z.enum(['draft', 'final']),
});

export type EncounterFormData = z.infer<typeof encounterSchema>;
